import { Routes } from '@angular/router';
import { MainRoutes } from './config/routes.config';
import { preAuthGuard } from '@modules/authorization/services/pre-auth-guard';
import { authGuard } from '@modules/authorization/services/auth-guard';

export const routes: Routes = [
  {
    path: MainRoutes.ROOT,
    loadChildren: () =>
      import('@modules/landing/landing.routes').then(m => m.landingRoutes),
  },
  {
    path: MainRoutes.AUTH,
    loadChildren: () =>
      import('@modules/authorization/authorization.routes').then(
        m => m.authorizationRoutes
      ),
    canActivate: [preAuthGuard],
  },
  {
    path: MainRoutes.ORDER,
    loadChildren: () =>
      import('@modules/order/order.routes').then(m => m.orderRoutes),
    canActivate: [authGuard],
  },
  {
    path: MainRoutes.SCORING,
    loadChildren: () =>
      import('@modules/scoring/scoring.routes').then(m => m.scoringRoutes),
    canActivate: [authGuard],
  },
  {
    path: MainRoutes.AGREEMENTS,
    loadChildren: () =>
      import('@modules/agreements/agreements.routes').then(
        m => m.agreementsRoutes
      ),
    canActivate: [authGuard],
  },
  {
    path: MainRoutes.CONDITIONS,
    loadChildren: () =>
      import('@modules/conditions/conditions.routes').then(
        m => m.conditionsRoutes
      ),
    canActivate: [authGuard],
  },
  {
    path: MainRoutes.PAYMENTS,
    loadChildren: () =>
      import('@modules/payment/payment.routes').then(m => m.paymentRoutes),
    canActivate: [authGuard],
  },
  {
    path: MainRoutes.STATUS,
    loadChildren: () =>
      import('@modules/status/status.routes').then(m => m.statusRoutes),
    canActivate: [authGuard],
  },
  {
    path: MainRoutes.OAUTH,
    loadComponent: () =>
      import(
        '@modules/redirect-msi/components/redirectMsiRoot/redirectMsiRoot.component'
      ).then(m => m.RedirectMsiRootComponent),
    canActivate: [preAuthGuard],
  },
  {
    path: MainRoutes.SHOW_IFRAME,
    loadComponent: () =>
      import('./shared/components/iframe/iframe.component').then(
        m => m.IframeComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: MainRoutes.PROFILE,
    loadChildren: () =>
      import('@modules/user-profile/user-profile.routes').then(
        m => m.userProfileRoutes
      ),
    canActivate: [authGuard],
  },
  {
    path: MainRoutes.DOCUMENTS,
    loadChildren: () =>
      import('@modules/documents/documents.routes').then(
        m => m.documentsRoutes
      ),
    canActivate: [authGuard],
  },
  {
    path: MainRoutes.ERROR,
    loadChildren: () =>
      import('@modules/errors/errors.routes').then(m => m.errorsRoutes),
  },
  {
    path: MainRoutes.UNKNOWN,
    redirectTo: 'error/page-not-found',
    pathMatch: 'full',
  },
];
